/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Organization } from './organization';
import { UserName } from './userName';


/**
 * All fields of a practice, for the practice detail view of the configuration page.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PracticeDetail { 
    readonly id: number;
    readonly name: string;
    readonly organizations: Array<Organization>;
    readonly street: string;
    readonly houseNumber: string;
    readonly postalCode: string;
    readonly city: string;
    readonly owner: UserName | null;
    readonly email: string;
    readonly phone: string;
    readonly websiteUrl: string;
    /**
     * Institutionskennzeichen
     */
    readonly institutionCode: string;
    readonly directionsUrl: string;
    readonly consentFormUrl: string;
    readonly privacyPolicyUrl: string;
    readonly googleReviewUrl: string;
    readonly allowsOnlineInitialAppointments: boolean;
    readonly logoUrl: string | null;
    readonly stampUrl: string | null;
}
export const PracticeDetail_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_name_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_organizations_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_street_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_houseNumber_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_postalCode_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_city_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_owner_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_email_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.email,];

export const PracticeDetail_phone_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_websiteUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_institutionCode_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_directionsUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_consentFormUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_privacyPolicyUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_googleReviewUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_allowsOnlineInitialAppointments_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_logoUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeDetail_stampUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];


